import type { ReactNode } from 'react';

export interface OrgModuleLayoutProps {
  title: string;
  description?: ReactNode;
  topSlot?: ReactNode;
  actions?: ReactNode;
  scrollMode?: 'content' | 'all';
  children?: ReactNode;
}

/**
 * Shared two-panel surface that keeps the top context (KPIs/shortcuts) anchored
 * while the bottom detail area scrolls. Individual modules can opt-out by not
 * passing `topSlot`, but the container still preserves the vertical rhythm so
 * future data cards can drop in without reflowing the main content.
 */
const OrgModuleLayout = ({ title, description, topSlot, actions, scrollMode = 'content', children }: OrgModuleLayoutProps) => {
  return (
    <article className="org-module">
      <header className="org-module__header">
        <div className="org-module__heading">
          <h1>{title}</h1>
          {description && <p>{description}</p>}
        </div>
        {actions && <div className="org-module__actions">{actions}</div>}
      </header>

      {scrollMode === 'content' ? (
        <>
          {topSlot ? <section className="org-module__top">{topSlot}</section> : null}
          {children != null ? <section className="org-module__content">{children}</section> : null}
        </>
      ) : (
        <section className="org-module__scroll">
          {topSlot ? <div className="org-module__top">{topSlot}</div> : null}
          {children != null ? <div className="org-module__content org-module__content--static">{children}</div> : null}
        </section>
      )}
    </article>
  );
};

export default OrgModuleLayout;
